(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 6740:
/***/ (function(module) {

/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/
(function(e,g){ true?module.exports=g():0})(this,function(){function e(b,a){if(!(this instanceof e))return new e(b,a);a=Object.assign({},m,a);var d=Math.pow(10,a.precision);this.intValue=b=g(b,a);this.value=b/d;a.increment=a.increment||1/d;a.groups=a.useVedic?n:p;this.s=a;this.p=d}function g(b,a){var d=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;var c=a.decimal;
var h=a.errorOnInvalid,k=a.fromCents,l=Math.pow(10,a.precision),f=b instanceof e;if(f&&k)return b.intValue;if("number"===typeof b||f)c=f?b.value:b;else if("string"===typeof b)h=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),c=(c=b.replace(/\((.*)\)/,"-$1").replace(h,"").replace(c,"."))||0;else{if(h)throw Error("Invalid Input");c=0}k||(c=(c*l).toFixed(4));return d?Math.round(c):c}var m={symbol:"$",separator:",",decimal:".",errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#",format:function(b,
a){var d=a.pattern,c=a.negativePattern,h=a.symbol,k=a.separator,l=a.decimal;a=a.groups;var f=(""+b).replace(/^-/,"").split("."),q=f[0];f=f[1];return(0<=b.value?d:c).replace("!",h).replace("#",q.replace(a,"$1"+k)+(f?l+f:""))},fromCents:!1},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;e.prototype={add:function(b){var a=this.s,d=this.p;return e((this.intValue+g(b,a))/(a.fromCents?1:d),a)},subtract:function(b){var a=this.s,d=this.p;return e((this.intValue-g(b,a))/(a.fromCents?1:d),a)},multiply:function(b){var a=
this.s;return e(this.intValue*b/(a.fromCents?1:Math.pow(10,a.precision)),a)},divide:function(b){var a=this.s;return e(this.intValue/g(b,a,!1),a)},distribute:function(b){var a=this.intValue,d=this.p,c=this.s,h=[],k=Math[0<=a?"floor":"ceil"](a/b),l=Math.abs(a-k*b);for(d=c.fromCents?1:d;0!==b;b--){var f=e(k/d,c);0<l--&&(f=f[0<=a?"add":"subtract"](1/d));h.push(f)}return h},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s;return"function"===
typeof b?b(this,a):a.format(this,Object.assign({},a,b))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return e});


/***/ }),

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this;if(!this.isValid())return $;var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=O.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:r};return n.replace(y,(function(t,e){return e||l[t]||r.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,n){ true?module.exports=n(__webpack_require__(7484)):0}(this,(function(e){"use strict";function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=n(e),a={s:"ein paar Sekunden",m:["eine Minute","einer Minute"],mm:"%d Minuten",h:["eine Stunde","einer Stunde"],hh:"%d Stunden",d:["ein Tag","einem Tag"],dd:["%d Tage","%d Tagen"],M:["ein Monat","einem Monat"],MM:["%d Monate","%d Monaten"],y:["ein Jahr","einem Jahr"],yy:["%d Jahre","%d Jahren"]};function i(e,n,t){var i=a[t];return Array.isArray(i)&&(i=i[n?0:1]),i.replace("%d",e)}var r={name:"de",weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,formats:{LTS:"HH:mm:ss",LT:"HH:mm",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},relativeTime:{future:"in %s",past:"vor %s",s:i,m:i,mm:i,h:i,hh:i,d:i,dd:i,M:i,MM:i,y:i,yy:i}};return t.default.locale(r,null,!0),r}));

/***/ }),

/***/ 5054:
/***/ (function(module) {

!function(e,n){ true?module.exports=n():0}(this,(function(){"use strict";return{name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")}}));

/***/ }),

/***/ 6023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,n){ true?module.exports=n(__webpack_require__(7484)):0}(this,(function(e){"use strict";function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=n(e),i={name:"fr",weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),weekStart:1,yearStart:4,formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinal:function(e){return""+e+(1===e?"er":"")}};return t.default.locale(i,null,!0),i}));

/***/ }),

/***/ 9182:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,a){ true?module.exports=a(__webpack_require__(7484)):0}(this,(function(e){"use strict";function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=a(e),d={name:"nl",weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",m:"een minuut",mm:"%d minuten",h:"een uur",hh:"%d uur",d:"een dag",dd:"%d dagen",M:"een maand",MM:"%d maanden",y:"een jaar",yy:"%d jaar"}};return n.default.locale(d,null,!0),d}));

/***/ }),

/***/ 7125:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organisation]/[shopId]/product/[reservationId]",
      function () {
        return __webpack_require__(9854);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ BackLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./icons/chevron-left.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M15 18l-6-6 6-6"
});

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref);
};

/* harmony default export */ var chevron_left = (SvgChevronLeft);
;// CONCATENATED MODULE: ./components/atoms/back-link.tsx




const BackLink = (props)=>{
    const { href , as , label  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: href,
        as: as,
        className: "flex p-2 pr-6 rounded text-md font-medium items-center hover:bg-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_left, {
                className: "h-6 w-6 mr-2"
            }),
            label
        ]
    });
};


/***/ }),

/***/ 2881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1748);



function Image(props) {
    let { url , alt , sizes , className , style , width =400 , height , fitMode =_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .ImageFitMode.Clip */ .B.Clip  } = props;
    let srcset = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>{
        return [
            0.5,
            1,
            2
        ].map((multiplier)=>{
            if (!url) return "";
            let calculatedWidth = width * multiplier;
            let calculatedHeight = height ? height * multiplier : undefined;
            return "".concat((0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, calculatedWidth, calculatedHeight, fitMode), " ").concat(calculatedWidth, "w");
        }).join(",");
    }, [
        url
    ]);
    let fallback = url ? (0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, width, height) : "#";
    return fallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        srcSet: srcset,
        sizes: sizes,
        src: fallback,
        alt: alt,
        title: alt,
        className: className,
        style: style
    }) : null;
}


/***/ }),

/***/ 5697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function Paragraph(props) {
    let { children  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "text-gray-700 whitespace-pre-wrap break-words",
        children: children
    });
}


/***/ }),

/***/ 9922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ OrderHint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(499);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5075);






const OrderHint = ()=>{
    let { order , organisation  } = (0,_contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__/* .useApplicationState */ .jm)();
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    if ((order === null || order === void 0 ? void 0 : order.status) !== _generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .OrderStatusEnumType.Created */ .GQ.Created) {
        return null;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-screen-xl mx-auto py-4",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(order.shopId, "/order/overview"),
                    className: "block w-full px-2 py-2 rounded border bg-brand-600 text-white mb-8 text-center font-medium",
                    children: translate("order.openOrderLink")
                })
            })
        });
    }
};


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ ReservationStatusEnumType; },
/* harmony export */   "GQ": function() { return /* binding */ OrderStatusEnumType; },
/* harmony export */   "Go": function() { return /* binding */ LanguageEnum; },
/* harmony export */   "Rx": function() { return /* binding */ UnitEnumType; }
/* harmony export */ });
/* unused harmony exports AllergensEnumType, AuthTypeEnum, ConnectionStatusEnum, CountryEnum, DeviceLogOperationEnum, DeviceLogTypeEnum, FirmwareTypeEnum, LockStatusEnum, LockerTemperatureTypeEnum, LogOperationEnum, NotificationTypeEnumType, QuotaTypeEnumType, SeverityEnumType, SortEnumType, UserRoleReferenceTypeEnum */
var AllergensEnumType;
(function(AllergensEnumType) {
    AllergensEnumType[/** Product contains peanuts */ "Peanuts"] = "peanuts";
    AllergensEnumType[/** Product contains nuts */ "Nuts"] = "nuts";
    AllergensEnumType[/** Product contains crustaceans (a type of shellfish) */ "Crustaceans"] = "crustaceans";
    AllergensEnumType[/** Product contains molluscs (a type of shellfish) */ "Molluscs"] = "molluscs";
    AllergensEnumType[/** Product contains fish */ "Fish"] = "fish";
    AllergensEnumType[/** Product contains eggs */ "Eggs"] = "eggs";
    AllergensEnumType[/** Product contains milk */ "Milk"] = "milk";
    AllergensEnumType[/** Product contains gluten */ "Gluten"] = "gluten";
    AllergensEnumType[/** Product contains soya */ "Soya"] = "soya";
    AllergensEnumType[/** Product contains sesame seeds */ "Sesame"] = "sesame";
    AllergensEnumType[/** Product contains celery */ "Celery"] = "celery";
    AllergensEnumType[/** Product contains mustard */ "Mustard"] = "mustard";
    AllergensEnumType[/** Product contains lupin */ "Lupin"] = "lupin";
    AllergensEnumType[/** Product contains sulphur dioxide */ "SulphurDioxide"] = "sulphurDioxide";
})(AllergensEnumType || (AllergensEnumType = {}));
var AuthTypeEnum;
(function(AuthTypeEnum) {
    AuthTypeEnum["Api"] = "api";
    AuthTypeEnum["User"] = "user";
})(AuthTypeEnum || (AuthTypeEnum = {}));
var ConnectionStatusEnum;
(function(ConnectionStatusEnum) {
    ConnectionStatusEnum[/** Device is online */ "Online"] = "Online";
    ConnectionStatusEnum[/** Device is offline */ "Offline"] = "Offline";
})(ConnectionStatusEnum || (ConnectionStatusEnum = {}));
var CountryEnum;
(function(CountryEnum) {
    CountryEnum["Be"] = "be";
    CountryEnum["Nl"] = "nl";
    CountryEnum["Fr"] = "fr";
    CountryEnum["De"] = "de";
    CountryEnum["At"] = "at";
})(CountryEnum || (CountryEnum = {}));
var DeviceLogOperationEnum;
(function(DeviceLogOperationEnum) {
    DeviceLogOperationEnum["State"] = "State";
    DeviceLogOperationEnum["Error"] = "Error";
    DeviceLogOperationEnum["LockerState"] = "LockerState";
    DeviceLogOperationEnum["RequestLockerConfig"] = "RequestLockerConfig";
    DeviceLogOperationEnum["TerminalAction"] = "TerminalAction";
    DeviceLogOperationEnum["RequestLatestVersion"] = "RequestLatestVersion";
    DeviceLogOperationEnum["Unknown"] = "Unknown";
    DeviceLogOperationEnum["GatewayConfigUpdate"] = "GatewayConfigUpdate";
    DeviceLogOperationEnum["LockerUpdate"] = "LockerUpdate";
    DeviceLogOperationEnum["OpenLocks"] = "OpenLocks";
    DeviceLogOperationEnum["ForceUpdate"] = "ForceUpdate";
    DeviceLogOperationEnum["LatestVersion"] = "LatestVersion";
})(DeviceLogOperationEnum || (DeviceLogOperationEnum = {}));
var DeviceLogTypeEnum;
(function(DeviceLogTypeEnum) {
    DeviceLogTypeEnum["Command"] = "Command";
    DeviceLogTypeEnum["Event"] = "Event";
})(DeviceLogTypeEnum || (DeviceLogTypeEnum = {}));
var FirmwareTypeEnum;
(function(FirmwareTypeEnum) {
    FirmwareTypeEnum["GatewayV1"] = "GatewayV1";
    FirmwareTypeEnum["LockControllerV1"] = "LockControllerV1";
    FirmwareTypeEnum["PinpadControllerV1"] = "PinpadControllerV1";
})(FirmwareTypeEnum || (FirmwareTypeEnum = {}));
var LanguageEnum;
(function(LanguageEnum) {
    LanguageEnum["Nl"] = "nl";
    LanguageEnum["Fr"] = "fr";
    LanguageEnum["En"] = "en";
    LanguageEnum["De"] = "de";
})(LanguageEnum || (LanguageEnum = {}));
var LockStatusEnum;
(function(LockStatusEnum) {
    LockStatusEnum[/** Lock is open */ "Open"] = "open";
    LockStatusEnum[/** Lock is closed */ "Closed"] = "closed";
})(LockStatusEnum || (LockStatusEnum = {}));
var LockerTemperatureTypeEnum;
(function(LockerTemperatureTypeEnum) {
    LockerTemperatureTypeEnum[/** Locker does not do any temperature control at all */ "NotCooled"] = "NotCooled";
    LockerTemperatureTypeEnum[/** Locker keeps room temperature (12-25°C) */ "RoomTemperature"] = "RoomTemperature";
    LockerTemperatureTypeEnum[/** Locker keeps refrigerator temperatures (3-6°C) */ "Refrigerated"] = "Refrigerated";
    LockerTemperatureTypeEnum[/** Locker keeps warm temperatures (60-80°C) */ "Heated"] = "Heated";
})(LockerTemperatureTypeEnum || (LockerTemperatureTypeEnum = {}));
var LogOperationEnum;
(function(LogOperationEnum) {
    LogOperationEnum["Received"] = "Received";
    LogOperationEnum["Sent"] = "Sent";
    LogOperationEnum["Opened"] = "Opened";
    LogOperationEnum["Error"] = "Error";
    LogOperationEnum["Created"] = "Created";
    LogOperationEnum["Updated"] = "Updated";
    LogOperationEnum["Deleted"] = "Deleted";
})(LogOperationEnum || (LogOperationEnum = {}));
var NotificationTypeEnumType;
(function(NotificationTypeEnumType) {
    NotificationTypeEnumType[/** Send sms notification */ "Sms"] = "sms";
    NotificationTypeEnumType[/** Send email notification */ "Email"] = "email";
})(NotificationTypeEnumType || (NotificationTypeEnumType = {}));
var OrderStatusEnumType;
(function(OrderStatusEnumType) {
    OrderStatusEnumType[/** Order has been created, not paid */ "Created"] = "Created";
    OrderStatusEnumType[/** Order has been paid */ "Paid"] = "Paid";
    OrderStatusEnumType[/** Order has expired */ "Expired"] = "Expired";
    OrderStatusEnumType[/** Pending order payment has been expired */ "PaymentExpired"] = "PaymentExpired";
    OrderStatusEnumType[/** Order has been canceled manually */ "Canceled"] = "Canceled";
    OrderStatusEnumType[/** Pending order payment has been canceled */ "PaymentCanceled"] = "PaymentCanceled";
    OrderStatusEnumType[/** Order has been refunded, this can only be done manually in the Mollie dashboard */ "Refunded"] = "Refunded";
})(OrderStatusEnumType || (OrderStatusEnumType = {}));
var QuotaTypeEnumType;
(function(QuotaTypeEnumType) {
    QuotaTypeEnumType[/** Quota is of type SMS */ "Sms"] = "SMS";
    QuotaTypeEnumType[/** Quota is of type Reservations */ "Reservations"] = "Reservations";
    QuotaTypeEnumType[/** Quota is of type Customers */ "Customers"] = "Customers";
    QuotaTypeEnumType[/** Quota is of type Emails */ "Emails"] = "Emails";
    QuotaTypeEnumType[/** Quota is of type Users */ "Users"] = "Users";
    QuotaTypeEnumType[/** Quota is of type Products */ "Products"] = "Products";
    QuotaTypeEnumType[/** Quota is of type Uploads */ "Uploads"] = "Uploads";
})(QuotaTypeEnumType || (QuotaTypeEnumType = {}));
var ReservationStatusEnumType;
(function(ReservationStatusEnumType) {
    ReservationStatusEnumType[/** Reservation has been cancelled */ "Cancelled"] = "cancelled";
    ReservationStatusEnumType[/** Reservation has been created */ "Created"] = "created";
    ReservationStatusEnumType[/** A box in the locker has been reserved */ "Reserved"] = "reserved";
    ReservationStatusEnumType[/**
   * Reservation has been ordered in the vending machine, not neccessarily paid. If
   * order gets cancelled or expires it will return to reserved.
   */ "Ordered"] = "ordered";
    ReservationStatusEnumType[/** Reservation ready notifications have been sent */ "Sent"] = "sent";
    ReservationStatusEnumType[/** Reservation has been picked up */ "Completed"] = "completed";
})(ReservationStatusEnumType || (ReservationStatusEnumType = {}));
var SeverityEnumType;
(function(SeverityEnumType) {
    SeverityEnumType["Info"] = "info";
    SeverityEnumType["Success"] = "success";
    SeverityEnumType["Warning"] = "warning";
    SeverityEnumType["Danger"] = "danger";
})(SeverityEnumType || (SeverityEnumType = {}));
var SortEnumType;
(function(SortEnumType) {
    SortEnumType["Asc"] = "asc";
    SortEnumType["Desc"] = "desc";
})(SortEnumType || (SortEnumType = {}));
var UnitEnumType;
(function(UnitEnumType) {
    UnitEnumType[/** Product is expressed in amount */ "Unit"] = "unit";
    UnitEnumType[/** Product/Price is per kilogram */ "Kg"] = "kg";
    UnitEnumType[/** Product/Price is per liter */ "Liter"] = "liter";
})(UnitEnumType || (UnitEnumType = {}));
var UserRoleReferenceTypeEnum;
(function(UserRoleReferenceTypeEnum) {
    UserRoleReferenceTypeEnum[/** An organisation/customer of the viresmo platform */ "Organisation"] = "Organisation";
    UserRoleReferenceTypeEnum[/** A dealer of the viresmo platform */ "Dealer"] = "Dealer";
    UserRoleReferenceTypeEnum[/** A reseller of the viresmo platform */ "Reseller"] = "Reseller";
})(UserRoleReferenceTypeEnum || (UserRoleReferenceTypeEnum = {}));


/***/ }),

/***/ 9854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@translator-app/react/lib/index.js
var lib = __webpack_require__(1477);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/atoms/back-link.tsx + 1 modules
var back_link = __webpack_require__(911);
// EXTERNAL MODULE: ./components/atoms/button/index.tsx + 4 modules
var atoms_button = __webpack_require__(7997);
// EXTERNAL MODULE: ./components/atoms/heading.tsx
var heading = __webpack_require__(2061);
// EXTERNAL MODULE: ./components/atoms/image.tsx
var atoms_image = __webpack_require__(2881);
;// CONCATENATED MODULE: ./components/atoms/mobile-action-container.tsx


const MobileActionContainer = (props)=>{
    let { children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:block",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed bottom-0 left-0 w-full md:hidden bg-white px-4 py-6",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/paragraph.tsx
var paragraph = __webpack_require__(5697);
// EXTERNAL MODULE: ./components/organisms/error-boundary.tsx
var error_boundary = __webpack_require__(3570);
// EXTERNAL MODULE: ./components/organisms/not-found.tsx
var not_found = __webpack_require__(1425);
// EXTERNAL MODULE: ./components/organisms/order-hint.tsx
var order_hint = __webpack_require__(9922);
// EXTERNAL MODULE: ./components/templates/fallback-page-template.tsx
var fallback_page_template = __webpack_require__(9169);
// EXTERNAL MODULE: ./components/templates/page-template.tsx + 1 modules
var page_template = __webpack_require__(3900);
// EXTERNAL MODULE: ./components/templates/shop-page-template.tsx + 4 modules
var shop_page_template = __webpack_require__(6781);
// EXTERNAL MODULE: ./contexts/application-state-context.tsx
var application_state_context = __webpack_require__(499);
// EXTERNAL MODULE: ./contexts/language-context.tsx + 4 modules
var language_context = __webpack_require__(5262);
// EXTERNAL MODULE: ./generated/graphql.tsx
var graphql = __webpack_require__(5075);
// EXTERNAL MODULE: ./utils/currency.ts
var currency = __webpack_require__(8734);
// EXTERNAL MODULE: ./utils/date-time.ts
var date_time = __webpack_require__(7008);
// EXTERNAL MODULE: ./utils/imgix.ts
var imgix = __webpack_require__(1748);
// EXTERNAL MODULE: ./utils/number.ts
var number = __webpack_require__(7627);
// EXTERNAL MODULE: ./utils/product.ts
var utils_product = __webpack_require__(996);
;// CONCATENATED MODULE: ./pages/[organisation]/[shopId]/product/[reservationId].tsx


























function AllergenIcon(props) {
    let { allergenType  } = props;
    let { translate  } = (0,lib.useTranslator)();
    let localisedAllergenName = translate("allergenEnum.".concat(allergenType));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-24 w-24 flex flex-col items-center justify-center border bg-white rounded mb-4 mr-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-16 h-16 p-2 flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/allergen-icons/".concat(allergenType, ".svg"),
                    alt: localisedAllergenName,
                    title: localisedAllergenName,
                    className: "max-h-full max-w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("font-medium uppercase", {
                    "text-sm": localisedAllergenName.length < 8,
                    "text-xs": localisedAllergenName.length >= 8
                }),
                children: localisedAllergenName
            })
        ]
    });
}
function ReservationContentOverview(props) {
    let { reservation  } = props;
    let { translate  } = (0,lib.useTranslator)();
    let allergens = react.useMemo(()=>{
        let allergensSet = new Set();
        for (let product of reservation.vendingProducts){
            const productDetails = product.product;
            if (productDetails) {
                for (let allergen of productDetails.allergens){
                    allergensSet.add(allergen);
                }
            }
        }
        return Array.from(allergensSet);
    }, [
        reservation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: allergens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* SubHeading */.G, {
                    children: translate("product.allergens")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-2 flex flex-wrap",
                    children: allergens.map((allergen)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AllergenIcon, {
                            allergenType: allergen
                        }, allergen);
                    })
                })
            ]
        })
    });
}
function NutritionalInformationTable(props) {
    let { nutritionalInformation  } = props;
    const indentedStyle = {
        maxWidth: "27.5rem"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* SubHeading */.G, {
                children: "Voedingstabel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-bold mb-1",
                        children: "Op basis van \xb1100g"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Energetische waarde (kCal)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.energy, " kCal")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Vetten"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.fat / 100, " g", 2, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-2 flex justify-between",
                        style: indentedStyle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Waarvan verzadigd"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.saturatedFat / 100, " g", 2, true)
                            })
                        ]
                    }),
                    nutritionalInformation.cholesterol > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Cholesterol"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.cholesterol / 100, " g", 2, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Koolhydraten"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.fiber / 100, " g", 2, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                style: indentedStyle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Suiker"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,number/* formatAmount */.dN)(nutritionalInformation.sugars / 100, " g", 2, true)
                                    })
                                ]
                            }),
                            nutritionalInformation.addedSugars > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                style: indentedStyle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Toegevoegde suiker"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,number/* formatAmount */.dN)(nutritionalInformation.addedSugars / 100, " g", 2, true)
                                    })
                                ]
                            })
                        ]
                    }),
                    nutritionalInformation.fiber > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Vezels"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.carbohydrate / 100, " g", 2, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Eiwitten"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.protein / 100, " g", 2, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between max-w-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Zout"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,number/* formatAmount */.dN)(nutritionalInformation.salt / 100, " g", 2, true)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function ProductDetails(props) {
    let { product , includeHeading =false  } = props;
    let { language  } = (0,language_context/* useLanguageContext */.Q)();
    let { translate  } = (0,lib.useTranslator)();
    let productName = react.useMemo(()=>{
        return (0,utils_product/* getLocalisedString */.T7)(product.name, language) || "Removed product";
    }, [
        product
    ]);
    let productDescription = react.useMemo(()=>{
        return (0,utils_product/* getLocalisedString */.T7)(product.description, language);
    }, [
        product
    ]);
    let allergens = product.allergens;
    let hasIncludedProducts = !!(product.includedProducts && product.includedProducts.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-4",
                children: [
                    includeHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* SubHeading */.G, {
                        children: productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* Paragraph */.n, {
                        children: productDescription
                    })
                ]
            }),
            hasIncludedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* Paragraph */.n, {
                    children: (0,utils_product/* getProductCollectionItemsSummary */.E5)(product.includedProducts)
                })
            }),
            allergens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* SubHeading */.G, {
                        children: translate("product.allergens")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap mt-2",
                        children: allergens.map((allergen)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AllergenIcon, {
                                allergenType: allergen
                            }, allergen);
                        })
                    })
                ]
            }),
            product.hasNutritionalInformation && /*#__PURE__*/ (0,jsx_runtime.jsx)(NutritionalInformationTable, {
                nutritionalInformation: product.nutritionalInformation
            }),
            hasIncludedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubProductsSection, {
                products: product.includedProducts.map((p)=>p.product).filter((p)=>!!p)
            })
        ]
    });
}
const SubProductsSection = /*#__PURE__*/ react.memo((props)=>{
    let { products  } = props;
    let [selectedProductIndex, setSelectedProductIndex] = react.useState(0);
    const filteredProducts = products.filter((p)=>!!p);
    const selectedProduct = filteredProducts[selectedProductIndex];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-start flex-wrap border-b pb-2",
                children: filteredProducts.map((product, i)=>{
                    let localisedName = (0,utils_product/* getLocalisedString */.T7)(product.name);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 mr-2",
                        children: selectedProductIndex === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "block relative font-medium border rounded text-gray-700 whitespace-no-wrap px-8 py-1",
                            children: localisedName
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* Button */.z, {
                            onPress: ()=>{
                                setSelectedProductIndex(i);
                            },
                            disabled: selectedProductIndex === i,
                            appearance: "secondary",
                            children: localisedName
                        })
                    }, product._id);
                })
            }),
            !!selectedProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                product: selectedProduct,
                includeHeading: true
            })
        ]
    });
});
function ProductPage(props) {
    var ref;
    let { reservation , shop , organisation  } = props;
    let router = (0,next_router.useRouter)();
    let { addToCart  } = (0,application_state_context/* useApplicationState */.jm)();
    let { language  } = (0,language_context/* useLanguageContext */.Q)();
    let { translate  } = (0,lib.useTranslator)();
    let [selectedImage, setSelectedImage] = react.useState(0);
    let name = react.useMemo(()=>{
        return (0,utils_product/* getReservationProductsName */.nd)(reservation, language) || "Removed product";
    }, [
        reservation
    ]);
    let prices = react.useMemo(()=>{
        return (0,utils_product/* getReservationPrices */.tF)(reservation);
    }, [
        reservation
    ]);
    let images = react.useMemo(()=>{
        return (0,utils_product/* getReservationProductImages */.iK)(reservation);
    }, [
        reservation
    ]);
    let pickupDateTime = react.useMemo(()=>{
        return dayjs_min_default()(Date.now()).add(shop.vendingPickupTime, "hour");
    }, [
        shop
    ]);
    let showReservationContent = react.useMemo(()=>{
        if (reservation.vendingProducts.length > 1) {
            return true;
        } else {
            return reservation.vendingProducts[0].amount > 1;
        }
    }, [
        reservation
    ]);
    const isSold = reservation.status !== graphql/* ReservationStatusEnumType.Reserved */.Fl.Reserved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-screen-xl mx-auto p-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(back_link/* BackLink */.h, {
                    href: "/[organisation]/[shopId]",
                    as: "".concat("/".concat(organisation.pathname, "/").concat(shop._id)),
                    label: translate("general.goBack")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:flex mt-2",
                children: [
                    !!images.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 md:w-1/2 lg:w-1/3 md:block flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_image/* Image */.E, {
                                    url: images[selectedImage],
                                    width: 400,
                                    height: 400,
                                    fitMode: imgix/* ImageFitMode.Crop */.B.Crop,
                                    sizes: "(min-width: 1024px) 400px, 800px",
                                    alt: name,
                                    className: "w-full h-auto"
                                }),
                                images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap",
                                    children: images.map((image, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mr-2 mt-2 cursor-pointer",
                                            onClick: ()=>{
                                                setSelectedImage(i);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_image/* Image */.E, {
                                                url: image,
                                                sizes: "200px",
                                                width: 200,
                                                height: 200,
                                                fitMode: imgix/* ImageFitMode.Crop */.B.Crop,
                                                alt: name,
                                                className: "w-24 h-24"
                                            })
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()({
                            "md:ml-8 md:w-1/2 lg:w-2/3": !!images.length,
                            "w-full": !images.length
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "border-b pb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-medium text-gray-600",
                                        children: translate("order.pickupAtDeadline", {
                                            pickupDateTime: (0,date_time/* formatDateTimeString */.I)(pickupDateTime, language)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-2",
                                        children: [
                                            prices.discountAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-lg text-gray-500 line-through",
                                                children: (0,currency/* formatCurrency */.x)(prices.totalPrice)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-2xl text-gray-700 mt-2 mb-4",
                                                children: (0,currency/* formatCurrency */.x)(prices.totalPriceWithDiscount)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActionContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col lg:w-64",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* Button */.z, {
                                                disabled: isSold,
                                                onPress: ()=>{
                                                    if (isSold) return;
                                                    addToCart([
                                                        reservation
                                                    ]);
                                                    router.push("/[organisation]/[shopId]/order/shopping-cart", "/".concat(organisation.pathname, "/").concat(shop._id, "/order/shopping-cart"));
                                                },
                                                appearance: "primary",
                                                size: "lg",
                                                children: translate(isSold ? "product.sold" : "product.orderButtonText")
                                            })
                                        })
                                    })
                                ]
                            }),
                            showReservationContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* Paragraph */.n, {
                                    children: (0,utils_product/* getProductCollectionItemsSummary */.E5)(reservation.vendingProducts)
                                })
                            }),
                            reservation.vendingProducts.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationContentOverview, {
                                        reservation: reservation
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubProductsSection, {
                                        products: reservation.vendingProducts.map((p)=>p.product).filter((p)=>!!p)
                                    })
                                ]
                            }) : ((ref = reservation.vendingProducts[0]) === null || ref === void 0 ? void 0 : ref.product) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                                product: reservation.vendingProducts[0].product
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}
function PageContent(props) {
    let { shop , organisation  } = props;
    let router = (0,next_router.useRouter)();
    let reservationId = router.query.reservationId;
    let { reservations  } = (0,application_state_context/* useApplicationState */.jm)();
    let { translate  } = (0,lib.useTranslator)();
    let foundReservation = react.useMemo(()=>{
        return reservations.find((r)=>r._id === reservationId);
    }, [
        reservations
    ]);
    if (foundReservation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage, {
            shop: shop,
            reservation: foundReservation,
            organisation: organisation
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-screen-xl p-8 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                    children: translate("product.noLongerAvailable")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* LinkButton */.Q, {
                        appearance: "primary",
                        size: "lg",
                        href: "/[organisation]/[shopId]",
                        as: "/".concat(organisation.pathname, "/").concat(shop._id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: translate("products.viewOurAvailableProducts")
                        })
                    })
                })
            ]
        });
    }
}
var __N_SSP = true;
function Index(props) {
    let { organisation , shop , shoppingCart , order , reservations , error  } = props;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fallback_page_template/* FallbackPageTemplate */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(error_boundary/* ErrorFallback */.H, {
                error: error
            })
        });
    }
    if (!organisation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_template/* PageTemplate */.P, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found/* NotFound */.T, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shop_page_template/* ShopPageTemplate */.g, {
        organisation: organisation,
        shop: shop,
        shoppingCart: shoppingCart,
        order: order,
        reservations: reservations,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(order_hint/* OrderHint */.H, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
                ...props
            })
        ]
    });
}


/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6740);
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(currency_js__WEBPACK_IMPORTED_MODULE_0__);

function formatCurrency(value) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let { isCentValue =true , showEuroSign =true  } = opts;
    let amount = isCentValue ? value / 100 : value;
    return currency_js__WEBPACK_IMPORTED_MODULE_0___default()(amount, {
        symbol: showEuroSign ? "€ " : "",
        separator: ".",
        decimal: ","
    }).format().trim();
}


/***/ }),

/***/ 7008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ formatDateTimeString; }
/* harmony export */ });
/* harmony import */ var dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9182);
/* harmony import */ var dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6023);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5054);
/* harmony import */ var dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(790);
/* harmony import */ var dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);





function formatDateTimeString(date) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "nl";
    return dayjs__WEBPACK_IMPORTED_MODULE_4___default()(date)// @ts-ignore
    .locale(locale).format("DD MMMM YYYY, HH:mm");
}


/***/ }),

/***/ 7627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "uu": function() { return /* binding */ formatProductUnitAmount; }
/* harmony export */ });
/* unused harmony exports formatTemperature, formatPercentage */
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);

function formatAmount(value) {
    let unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2, enforceDecimals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    let formattedValue = Math.round(value * 10 ** decimals) / 10 ** decimals;
    if (enforceDecimals) {
        formattedValue = formattedValue.toFixed(decimals);
    } else {
        formattedValue = formattedValue.toString();
    }
    return "".concat(formattedValue.replace(".", ",")).concat(unit ? unit : "");
}
function formatTemperature(value) {
    return formatAmount(value, "\xb0C");
}
function formatPercentage(value) {
    return formatAmount(value * 100, "%");
}
function formatProductUnitAmount(amount, unitType) {
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit) {
        return "".concat(amount.toString(10), "x");
    }
    let value = amount;
    if (amount > 1000) {
        value = amount / 1000;
    }
    let suffix = "";
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Liter */ .Rx.Liter) {
        suffix = amount > 1000 ? "l" : "cl";
    } else {
        suffix = amount > 1000 ? "kg" : "g";
    }
    return formatAmount(value, suffix, 2, amount > 1000);
}


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ getProductCollectionItemsSummary; },
/* harmony export */   "T7": function() { return /* binding */ getLocalisedString; },
/* harmony export */   "iK": function() { return /* binding */ getReservationProductImages; },
/* harmony export */   "nd": function() { return /* binding */ getReservationProductsName; },
/* harmony export */   "tF": function() { return /* binding */ getReservationPrices; }
/* harmony export */ });
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);
/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7627);


function getLocalisedString(value) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    var ref;
    let foundValue = value.find((i)=>i.language === language);
    return foundValue ? foundValue.value : ((ref = value[0]) === null || ref === void 0 ? void 0 : ref.value) || "";
}
function getReservationProductsName(reservation) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    let nameValues = reservation.vendingProducts.filter((p)=>{
        var ref;
        return !!(p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.name);
    }).map((p)=>{
        var ref;
        var ref1;
        return "".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    });
    return "".concat(nameValues.slice(0, 2).join(", ")).concat(nameValues.length > 2 ? ", ..." : "");
}
function getReservationProductImages(reservation) {
    let newImages = [];
    for (let vendingProduct of reservation.vendingProducts){
        var ref;
        if (vendingProduct === null || vendingProduct === void 0 ? void 0 : (ref = vendingProduct.product) === null || ref === void 0 ? void 0 : ref.imageUrl) {
            var ref1, ref2;
            newImages.push(vendingProduct.product.imageUrl);
            if ((ref1 = vendingProduct.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.includedProducts) === null || ref2 === void 0 ? void 0 : ref2.length) {
                for (let includedProduct of vendingProduct.product.includedProducts){
                    var ref3;
                    if (includedProduct === null || includedProduct === void 0 ? void 0 : (ref3 = includedProduct.product) === null || ref3 === void 0 ? void 0 : ref3.imageUrl) {
                        newImages.push(includedProduct.product.imageUrl);
                    }
                }
            }
        }
    }
    return newImages.filter((img)=>!!img);
}
function getProductCollectionItemsSummary(products) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    return products.filter((p)=>{
        var ref;
        return !!((p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) && (p === null || p === void 0 ? void 0 : p.amount));
    }).map((p)=>{
        var ref;
        var ref1;
        return "- ".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    }).join("\n");
}
function getReservationPrices(reservation) {
    var _vendingTotalPrice;
    const vendingTotalPrice = (_vendingTotalPrice = reservation.vendingTotalPrice) !== null && _vendingTotalPrice !== void 0 ? _vendingTotalPrice : 0;
    const vendingDiscount = reservation.vendingDiscount ? reservation.vendingDiscount / 10000 : 0;
    const discountAmount = vendingTotalPrice * vendingDiscount;
    const totalPriceWithDiscount = vendingTotalPrice - discountAmount;
    var _vendingTotalPrice1;
    return {
        discountAmount,
        totalPriceWithDiscount,
        totalPrice: (_vendingTotalPrice1 = reservation.vendingTotalPrice) !== null && _vendingTotalPrice1 !== void 0 ? _vendingTotalPrice1 : 0
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,444,960,774,888,179], function() { return __webpack_exec__(7125); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);